import { render } from "./Textarea.vue?vue&type=template&id=f11cdda2"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__